/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Employee } from './Employee';
import {
    EmployeeFromJSON,
    EmployeeFromJSONTyped,
    EmployeeToJSON,
    EmployeeToJSONTyped,
} from './Employee';

/**
 * 
 * @export
 * @interface CreateEmployeeResponse
 */
export interface CreateEmployeeResponse {
    /**
     * 
     * @type {Employee}
     * @memberof CreateEmployeeResponse
     */
    data: Employee;
}

/**
 * Check if a given object implements the CreateEmployeeResponse interface.
 */
export function instanceOfCreateEmployeeResponse(value: object): value is CreateEmployeeResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function CreateEmployeeResponseFromJSON(json: any): CreateEmployeeResponse {
    return CreateEmployeeResponseFromJSONTyped(json, false);
}

export function CreateEmployeeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateEmployeeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': EmployeeFromJSON(json['data']),
    };
}

  export function CreateEmployeeResponseToJSON(json: any): CreateEmployeeResponse {
      return CreateEmployeeResponseToJSONTyped(json, false);
  }

  export function CreateEmployeeResponseToJSONTyped(value?: CreateEmployeeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': EmployeeToJSON(value['data']),
    };
}

